import React, { useRef, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const LABELS = ["00:00", "02:00", "04:00", "06:00", "12:00", "18:00", "24:00", "Now"];
const TOTAL_RUNS  = [105, 165, 145, 205, 205, 230, 205, 260];
const FAILED_RUNS = [45,  48,  78,  50,  85,  65,  100, 70];

const chartValues = {
    trends: {
        Labels: ["00:00", "02:00", "04:00", "06:00", "12:00", "18:00", "24:00", "Now"],
        totalRuns: [105, 165, 145, 205, 205, 230, 205, 260],
        failedRuns:  [45,  48,  78,  50,  85,  65,  100, 70]
    },
    health: {
        Labels: ["00:00", "02:00", "04:00", "06:00", "12:00", "18:00", "24:00", "Now"],
        totalRuns: [90, 130, 168, 220, 205, 210, 205, 270],
        failedRuns:  [55,  44, 50 , 84, 70,  85,  60,  100, 80]
    }
}

  const staticChartData = {
  labels: LABELS,
  datasets: [
    {
      label: "Total Runs",
    //   data: chartValues[activeTab]?.totalRuns || TOTAL_RUNS,
      data: TOTAL_RUNS,
      borderColor: "#29b6f6",
      backgroundColor: "rgba(41,182,246,0.15)", // gradient injected after mount
      fill: true,
      tension: 0.4,
      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#29b6f6",
      pointBorderWidth: 2,
      pointRadius: 5,
      pointHoverRadius: 7,
      borderWidth: 2,
    },
    {
      label: "Failed Runs",
    //   data: chartValues[activeTab]?.failedRuns || FAILED_RUNS,
      data: FAILED_RUNS,
      borderColor: "#ef5350",
      backgroundColor: "rgba(239, 120, 100, 0.15)",
      fill: false,
      tension: 0.4,
      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#ef5350",
      pointBorderWidth: 2,
      pointRadius: 5,
      pointHoverRadius: 7,
      borderWidth: 2,
    },
  ],
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    duration: 1400,
    easing: "easeInOutQuart",
    x: { from: 0 },         
    y: {
      from: (ctx) => ctx.chart.scales.y.getPixelForValue(0),
    },
  },
  clip: false,
  interaction: { mode: "index", intersect: false },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgba(255,255,255,0.97)",
      titleColor: "#111827",
      bodyColor: "#4b5563",
      borderColor: "#e5e7eb",
      borderWidth: 1,
      padding: 10,
      cornerRadius: 8,
    },
  },
  scales: {
    x: {
      grid: { color: "rgba(0,0,0,0.06)", drawTicks: false },
      border: { dash: [4, 4] },
      ticks: { color: "#9ca3af", font: { size: 11 }, autoSkip: false, maxRotation: 0 },
    },
    y: {
      min: 0,
      max: 320,
      ticks: { stepSize: 50, color: "#9ca3af", font: { size: 11 } },
      grid: { color: "rgba(0,0,0,0.05)", drawTicks: false },
      border: { display: false },
    },
  },
};

const SystemTrendChart = ({activeTab}) => {
  const chartRef = useRef(null);
  // const dyna

  // Inject gradient after mount
  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;

    const ctx = chart.ctx;
    const grad = ctx.createLinearGradient(0, 0, 0, 260);
    grad.addColorStop(0, "rgba(41,182,246,0.28)");
    grad.addColorStop(1, "rgba(41,182,246,0.02)");

    chart.data.datasets[0].backgroundColor = grad;
    chart.update("none"); 
  }, []);

  return (
    <div style={{ position: "relative", height: "380px", width: "100%" }}>
      <Line
        ref={chartRef}
        data={staticChartData}
        options={chartOptions}
      />
    </div>
  );
};

export default SystemTrendChart;